export default __webpack_public_path__ + "3978ab4ec5ecb690d9ba0bf32a3d2d54.svg";